
function SanitizePasswordFunction(input) {

let textoSemAcento = input.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
let sanitizedInput = textoSemAcento.replace(/[^A-Za-z0-9@#$&!*]/g, "");

return sanitizedInput;

}

export default SanitizePasswordFunction;